"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";

/**
 * Mount children only when near the viewport — cuts TBT while minHeight reserves layout (CLS).
 */
export default function LazyOnView(t0) {
  const $ = _c(11);
  const {
    children,
    minHeight: t1,
    rootMargin: t2,
    className: t3
  } = t0;
  const minHeight = t1 === undefined ? 320 : t1;
  const rootMargin = t2 === undefined ? "240px 0px" : t2;
  const className = t3 === undefined ? "" : t3;
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  let t4;
  let t5;
  if ($[0] !== rootMargin || $[1] !== visible) {
    t4 = () => {
      const node = ref.current;
      if (!node || visible) {
        return;
      }
      if (typeof IntersectionObserver === "undefined") {
        setVisible(true);
        return;
      }
      const observer = new IntersectionObserver(t6 => {
        const [entry] = t6;
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      }, {
        rootMargin,
        threshold: 0.01
      });
      observer.observe(node);
      return () => observer.disconnect();
    };
    t5 = [rootMargin, visible];
    $[0] = rootMargin;
    $[1] = visible;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  useEffect(t4, t5);
  let t6;
  if ($[4] !== minHeight || $[5] !== visible) {
    t6 = visible ? undefined : {
      minHeight
    };
    $[4] = minHeight;
    $[5] = visible;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = visible ? children : null;
  let t8;
  if ($[7] !== className || $[8] !== t6 || $[9] !== t7) {
    t8 = <div ref={ref} className={className} style={t6}>{t7}</div>;
    $[7] = className;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}